import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/massUpdate';

const namespace = 'ANALYSIS';

export const FETCH_MASS_UPDATE_PROPERTIES_NOT_INCLUDED = createRequestTypes(
  `${namespace}/FETCH_MASS_UPDATE_PROPERTIES_NOT_INCLUDED`,
);

export const fetchMassUpdatePropertiesNotIncluded = makeApiActionCreatorV3(
  api.fetchMassUpdatePropertiesNotIncluded,
  FETCH_MASS_UPDATE_PROPERTIES_NOT_INCLUDED[START],
  FETCH_MASS_UPDATE_PROPERTIES_NOT_INCLUDED[SUCCESS],
  FETCH_MASS_UPDATE_PROPERTIES_NOT_INCLUDED[ERROR],
);

export const FETCH_MASS_UPDATE_ERRORS = createRequestTypes(
  `${namespace}/FETCH_MASS_UPDATE_ERRORS`,
);

export const fetchMassUpdateErrors = makeApiActionCreatorV3(
  api.fetchMassUpdateErrors,
  FETCH_MASS_UPDATE_ERRORS[START],
  FETCH_MASS_UPDATE_ERRORS[SUCCESS],
  FETCH_MASS_UPDATE_ERRORS[ERROR],
);

export const FETCH_DROPDOWNS = createRequestTypes(
  `${namespace}/FETCH_DROPDOWNS`,
);

export const fetchDropdowns = makeApiActionCreatorV3(
  api.getDropdownValues,
  FETCH_DROPDOWNS[START],
  FETCH_DROPDOWNS[SUCCESS],
  FETCH_DROPDOWNS[ERROR],
);

export const FETCH_CODEFILE = createRequestTypes(`${namespace}/FETCH_CODEFILE`);

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODEFILE[START],
  FETCH_CODEFILE[SUCCESS],
  FETCH_CODEFILE[ERROR],
);

export const FETCH_ALL_MASS_UPDATE_GROUPS = createRequestTypes(
  `${namespace}/FETCH_ALL_MASS_UPDATE_GROUPS`,
);

export const fetchAllMassUpdateGroups = makeApiActionCreatorV3(
  api.fetchAllMassUpdateGroups,
  FETCH_ALL_MASS_UPDATE_GROUPS[START],
  FETCH_ALL_MASS_UPDATE_GROUPS[SUCCESS],
  FETCH_ALL_MASS_UPDATE_GROUPS[ERROR],
);

export const FETCH_MASS_UPDATE_GROUP_SINGLE = createRequestTypes(
  `${namespace}/FETCH_MASS_UPDATE_GROUP_SINGLE`,
);

export const fetchMassUpdateGroupSingle = makeApiActionCreatorV3(
  api.fetchMassUpdateGroupSingle,
  FETCH_MASS_UPDATE_GROUP_SINGLE[START],
  FETCH_MASS_UPDATE_GROUP_SINGLE[SUCCESS],
  FETCH_MASS_UPDATE_GROUP_SINGLE[ERROR],
);

export const fetchAppealMassUpdateJob = makeApiActionCreatorV3(
  api.fetchAppealMassUpdateJob,
  FETCH_MASS_UPDATE_GROUP_SINGLE[START],
  FETCH_MASS_UPDATE_GROUP_SINGLE[SUCCESS],
  FETCH_MASS_UPDATE_GROUP_SINGLE[ERROR],
);

export const FETCH_MASS_UPDATE_CONFIG = createRequestTypes(
  `${namespace}/FETCH_MASS_UPDATE_CONFIG`,
);

export const fetchMassUpdateConfig = makeApiActionCreatorV3(
  api.fetchMassUpdateConfig,
  FETCH_MASS_UPDATE_CONFIG[START],
  FETCH_MASS_UPDATE_CONFIG[SUCCESS],
  FETCH_MASS_UPDATE_CONFIG[ERROR],
);

export const FETCH_SALES_MASS_UPDATE_CONFIG = createRequestTypes(
  `${namespace}/FETCH_SALES_MASS_UPDATE_CONFIG`,
);

export const fetchSalesMassUpdateConfig = makeApiActionCreatorV3(
  api.fetchSalesMassUpdateConfig,
  FETCH_SALES_MASS_UPDATE_CONFIG[START],
  FETCH_SALES_MASS_UPDATE_CONFIG[SUCCESS],
  FETCH_SALES_MASS_UPDATE_CONFIG[ERROR],
);

export const DELETE_MASS_UPDATE_GROUP_DISCRETE = createRequestTypes(
  `${namespace}/DELETE_MASS_UPDATE_GROUP_DISCRETE`,
);

export const deleteMassUpdateGroupDiscrete = makeApiActionCreatorV3(
  api.deleteMassUpdateGroup,
  DELETE_MASS_UPDATE_GROUP_DISCRETE[START],
  DELETE_MASS_UPDATE_GROUP_DISCRETE[SUCCESS],
  DELETE_MASS_UPDATE_GROUP_DISCRETE[ERROR],
);

export const DELETE_MASS_UPDATE_GROUP = createRequestTypes(
  `${namespace}/DELETE_MASS_UPDATE_GROUP`,
);

export const deleteMassUpdateGroup = makeApiActionCreatorV3(
  api.deleteMassUpdateGroup,
  DELETE_MASS_UPDATE_GROUP[START],
  DELETE_MASS_UPDATE_GROUP[SUCCESS],
  DELETE_MASS_UPDATE_GROUP[ERROR],
);

export const INSERT_MASS_UPDATE_GROUP = createRequestTypes(
  `${namespace}/INSERT_MASS_UPDATE_GROUP`,
);

export const insertMassUpdateGroup = makeApiActionCreatorV3(
  api.insertMassUpdateGroup,
  INSERT_MASS_UPDATE_GROUP[START],
  INSERT_MASS_UPDATE_GROUP[SUCCESS],
  INSERT_MASS_UPDATE_GROUP[ERROR],
);

export const LOAD_MASS_UPDATE_ACTIONS = createRequestTypes(
  `${namespace}/LOAD_MASS_UPDATE_ACTIONS`,
);

export const loadMassUpdateActions = makeApiActionCreatorV3(
  api.loadMassUpdateActions,
  LOAD_MASS_UPDATE_ACTIONS[START],
  LOAD_MASS_UPDATE_ACTIONS[SUCCESS],
  LOAD_MASS_UPDATE_ACTIONS[ERROR],
);

export const INSERT_MASS_UPDATE_ACTION = createRequestTypes(
  `${namespace}/INSERT_MASS_UPDATE_ACTION`,
);

export const insertMassUpdateAction = makeApiActionCreatorV3(
  api.insertMassUpdateAction,
  INSERT_MASS_UPDATE_ACTION[START],
  INSERT_MASS_UPDATE_ACTION[SUCCESS],
  INSERT_MASS_UPDATE_ACTION[ERROR],
);

export const UPDATE_MASS_UPDATE_ACTION = createRequestTypes(
  `${namespace}/UPDATE_MASS_UPDATE_ACTION`,
);

export const updateMassUpdateAction = makeApiActionCreatorV3(
  api.updateMassUpdateAction,
  UPDATE_MASS_UPDATE_ACTION[START],
  UPDATE_MASS_UPDATE_ACTION[SUCCESS],
  UPDATE_MASS_UPDATE_ACTION[ERROR],
);

export const MASS_INSERT_EVIDENCE_UPLOAD = createRequestTypes(
  `${namespace}/MASS_INSERT_EVIDENCE_UPLOAD`,
);

export const massInsertEvidenceUpload = makeApiActionCreatorV3(
  api.massInsertEvidenceUpload,
  MASS_INSERT_EVIDENCE_UPLOAD[START],
  MASS_INSERT_EVIDENCE_UPLOAD[SUCCESS],
  MASS_INSERT_EVIDENCE_UPLOAD[ERROR],
);

export const PERFORM_MASS_INSERT_EVIDENCE = createRequestTypes(
  `${namespace}/PERFORM_MASS_INSERT_EVIDENCE`,
);

export const performMassInsertEvidence = makeApiActionCreatorV3(
  api.performMassInsertEvidence,
  PERFORM_MASS_INSERT_EVIDENCE[START],
  PERFORM_MASS_INSERT_EVIDENCE[SUCCESS],
  PERFORM_MASS_INSERT_EVIDENCE[ERROR],
);

export const MASS_UPDATE_BUILDER_ADJUSTMENTS = createRequestTypes(
  `${namespace}/MASS_UPDATE_BUILDER_ADJUSTMENTS`,
);

export const massUpdateBuilderAdjustments = makeApiActionCreatorV3(
  api.massUpdateBuilderAdjustments,
  MASS_UPDATE_BUILDER_ADJUSTMENTS[START],
  MASS_UPDATE_BUILDER_ADJUSTMENTS[SUCCESS],
  MASS_UPDATE_BUILDER_ADJUSTMENTS[ERROR],
);

export const PERFORM_MASS_UPDATE = createRequestTypes(
  `${namespace}/PERFORM_MASS_UPDATE`,
);

export const performMassUpdate = makeApiActionCreatorV3(
  api.performMassUpdate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const PERFORM_VALUATION_MASS_UPDATE = createRequestTypes(
  `${namespace}/PERFORM_VALUATION_MASS_UPDATE`,
);

export const performValuationMassUpdate = makeApiActionCreatorV3(
  api.performValuationMassUpdate,
  PERFORM_VALUATION_MASS_UPDATE[START],
  PERFORM_VALUATION_MASS_UPDATE[SUCCESS],
  PERFORM_VALUATION_MASS_UPDATE[ERROR],
);

export const PERFORM_VALUATION_BY_TYPE_MASS_UPDATE = createRequestTypes(
  `${namespace}/PERFORM_VALUATION_BY_TYPE_MASS_UPDATE`,
);

export const performValuationByTypeMassUpdate = makeApiActionCreatorV3(
  api.performValuationByTypeMassUpdate,
  PERFORM_VALUATION_BY_TYPE_MASS_UPDATE[START],
  PERFORM_VALUATION_BY_TYPE_MASS_UPDATE[SUCCESS],
  PERFORM_VALUATION_BY_TYPE_MASS_UPDATE[ERROR],
);

export const VALIDATE_VALUATION_BY_TYPE_MASS_UPDATE = createRequestTypes(
  `${namespace}/VALIDATE_VALUATION_BY_TYPE_MASS_UPDATE`,
);

export const validateValuationByTypeMassUpdate = makeApiActionCreatorV3(
  api.validateValuationByTypeMassUpdate,
  VALIDATE_VALUATION_BY_TYPE_MASS_UPDATE[START],
  VALIDATE_VALUATION_BY_TYPE_MASS_UPDATE[SUCCESS],
  VALIDATE_VALUATION_BY_TYPE_MASS_UPDATE[ERROR],
);

export const PERFORM_INSPECTION_MASS_UPDATE = createRequestTypes(
  `${namespace}/PERFORM_INSPECTION_MASS_UPDATE`,
);

export const performInspectionMassUpdate = makeApiActionCreatorV3(
  api.performInspectionMassUpdate,
  PERFORM_INSPECTION_MASS_UPDATE[START],
  PERFORM_INSPECTION_MASS_UPDATE[SUCCESS],
  PERFORM_INSPECTION_MASS_UPDATE[ERROR],
);

export const PERFORM_PERMIT_MASS_UPDATE = createRequestTypes(
  `${namespace}/PERFORM_PERMIT_MASS_UPDATE`,
);

export const performPermitMassUpdate = makeApiActionCreatorV3(
  api.performPermitMassUpdate,
  PERFORM_PERMIT_MASS_UPDATE[START],
  PERFORM_PERMIT_MASS_UPDATE[SUCCESS],
  PERFORM_PERMIT_MASS_UPDATE[ERROR],
);

export const PERFORM_PROPERTY_EVENTS_MASS_UPDATE = createRequestTypes(
  `${namespace}/PERFORM_PROPERTY_EVENTS_MASS_UPDATE`,
);

export const performPropertyEventsMassUpdate = makeApiActionCreatorV3(
  api.performPropertyEventsMassUpdate,
  PERFORM_PROPERTY_EVENTS_MASS_UPDATE[START],
  PERFORM_PROPERTY_EVENTS_MASS_UPDATE[SUCCESS],
  PERFORM_PROPERTY_EVENTS_MASS_UPDATE[ERROR],
);

export const performAppealMassUpdate = makeApiActionCreatorV3(
  api.performAppealMassUpdate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const performCaseMassUpdate = makeApiActionCreatorV3(
  api.performCaseMassUpdate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const FETCH_SALES_MASS_UPDATE_RUNS = createRequestTypes(
  `${namespace}/FETCH_SALES_MASS_UPDATE_RUNS`,
);

export const fetchSaleMassUpdateRuns = makeApiActionCreatorV3(
  api.fetchSaleMassUpdateRuns,
  FETCH_SALES_MASS_UPDATE_RUNS[START],
  FETCH_SALES_MASS_UPDATE_RUNS[SUCCESS],
  FETCH_SALES_MASS_UPDATE_RUNS[ERROR],
);

export const FETCH_SALES_MASS_UPDATE_RUN = createRequestTypes(
  `${namespace}/FETCH_SALES_MASS_UPDATE_RUN`,
);

export const fetchSaleMassUpdateRun = makeApiActionCreatorV3(
  api.fetchSaleMassUpdateRun,
  FETCH_SALES_MASS_UPDATE_RUN[START],
  FETCH_SALES_MASS_UPDATE_RUN[SUCCESS],
  FETCH_SALES_MASS_UPDATE_RUN[ERROR],
);

export const performSaleMassUpdate = makeApiActionCreatorV3(
  api.performSaleMassUpdate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const performAppealHearingLetterMassUpdate = makeApiActionCreatorV3(
  api.performAppealHearingLetterMassUpdate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const performAppealLetterMassGenerate = makeApiActionCreatorV3(
  api.performAppealLetterMassGenerate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const fetchAppealLetterMassGenerateJob = makeApiActionCreatorV3(
  api.fetchAppealLetterMassGenerateJob,
  FETCH_MASS_UPDATE_GROUP_SINGLE[START],
  FETCH_MASS_UPDATE_GROUP_SINGLE[SUCCESS],
  FETCH_MASS_UPDATE_GROUP_SINGLE[ERROR],
);

export const performEvidencePacketMassGenerate = makeApiActionCreatorV3(
  api.performEvidencePacketMassGenerate,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const performEvidencePacketMassPublish = makeApiActionCreatorV3(
  api.performEvidencePacketMassPublish,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const performCreateControlGroup = makeApiActionCreatorV3(
  api.performCreateControlGroup,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const performMassUpdateControlGroup = makeApiActionCreatorV3(
  api.performMassUpdateControlGroup,
  PERFORM_MASS_UPDATE[START],
  PERFORM_MASS_UPDATE[SUCCESS],
  PERFORM_MASS_UPDATE[ERROR],
);

export const UNDO_MASS_UPDATE = createRequestTypes(
  `${namespace}/UNDO_MASS_UPDATE`,
);

export const undoMassUpdate = makeApiActionCreatorV3(
  api.undoMassUpdate,
  UNDO_MASS_UPDATE[START],
  UNDO_MASS_UPDATE[SUCCESS],
  UNDO_MASS_UPDATE[ERROR],
);

export const FETCH_APPRAISER_TYPES = createRequestTypes(
  `${namespace}/FETCH_APPRAISER_TYPES`,
);

export const fetchAppraiserTypes = makeApiActionCreatorV3(
  api.fetchAppraiserTypes,
  FETCH_APPRAISER_TYPES[START],
  FETCH_APPRAISER_TYPES[SUCCESS],
  FETCH_APPRAISER_TYPES[ERROR],
);

export const FETCH_APPRAISERS = createRequestTypes(
  `${namespace}/FETCH_APPRAISERS`,
);

export const fetchAppraisers = makeApiActionCreatorV3(
  api.fetchAppraisers,
  FETCH_APPRAISERS[START],
  FETCH_APPRAISERS[SUCCESS],
  FETCH_APPRAISERS[ERROR],
);

export const FETCH_PROPERTY_TYPES = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_TYPES`,
);

export const fetchPropertyTypes = makeApiActionCreatorV3(
  api.fetchPropertyTypes,
  FETCH_PROPERTY_TYPES[START],
  FETCH_PROPERTY_TYPES[SUCCESS],
  FETCH_PROPERTY_TYPES[ERROR],
);

export const RESET_UPDATE_DATA = `${namespace}/RESET_UPDATE_DATA`;

export function resetUpdateData() {
  return async dispatch => {
    dispatch({ type: RESET_UPDATE_DATA });
  };
}

export const SET_MANUAL_DROPDOWNS = `${namespace}/SET_MANUAL_DROPDOWNS`;

export function setManualDropdowns(data) {
  return async dispatch => {
    dispatch({ type: SET_MANUAL_DROPDOWNS, data });
  };
}
